import { ShootingClearanceCategory } from '@api/shootingApi/interfaces';
import { WeaponGroupDefinition } from '@api/shootingApi/interfaces';
import { WeaponGroup } from '@api/disciplinesApi/interfaces';
import { TFunction } from 'i18next';

export const ORDERED_CLEARANCE_CATEGORIES: ShootingClearanceCategory[] = [
  'air',
  'small_bore',
  'large_bore',
];

export const clearanceCategoryLabel = (
  category: ShootingClearanceCategory,
  t: TFunction
): string => t(`shooting:clearanceCategories.${category}`);

export const buildWeaponGroupCategoryMap = (
  definitions: WeaponGroupDefinition[]
): Map<WeaponGroup, ShootingClearanceCategory> => {
  const map = new Map<WeaponGroup, ShootingClearanceCategory>();

  definitions.forEach((definition) => {
    map.set(definition.code as WeaponGroup, definition.clearanceCategory);
  });

  return map;
};

export const resolveRequiredClearanceCategories = (
  requiredWeaponGroups: WeaponGroup[],
  categoryByCode: Map<WeaponGroup, ShootingClearanceCategory>
): ShootingClearanceCategory[] => {
  const categories = requiredWeaponGroups
    .map((code) => categoryByCode.get(code))
    .filter((category): category is ShootingClearanceCategory => category !== undefined);

  return [...new Set(categories)];
};
